import React, { useState, useEffect } from 'react';
import { trackFooterBannerClick } from '../utils/analytics';

// Sponsor banner configuration - easy to add/remove sponsors
const SPONSORS = [
  {
    id: 0,
    image: 'images/fermenta.png',
    alt: 'Edital Fermenta',
    link: 'https://www.academiadacerveja.com/',
  },
  {
    id: 1,
    image: 'images/beersales.png',
    alt: 'Beer Sales',
    link: 'http://lp1.beersales.com.br/',
  },
  {
    id: 1,
    image: 'images/academia.png',
    alt: 'Academia da Cerveja',
    link: 'https://www.academiadacerveja.com/',
  },
  {
    id: 2,
    image: 'images/luci.png',
    alt: 'Luci',
    link: 'https://www.bebaluci.com.br/',
  },
  {
    id: 3,
    image: 'images/pinnacle.png',
    alt: 'Pinnacle',
    link: 'https://www.npbrewing.com.br',
  },
  {
    id: 4,
    image: 'images/rotacervejeira.png',
    alt: 'Rota Cervejeira',
    link: 'https://www.instagram.com/rotacervejeirarj/',
  },
  {
    id: 5,
    image: 'images/sindicerv.png',
    alt: 'SindiCerv',
    link: 'https://sindicerv.com.br/',
  },
  {
    id: 6,
    image: 'images/stannis.png',
    alt: 'Stannis',
    link: 'https://www.stannis.com.br',
  },
  {
    id: 7,
    image: 'images/brasil-brau.png',
    alt: 'Brasil Brau',
    link: 'https://www.brasilbrau.com',
  }
];

export function Footer() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Rotate banner every 3 seconds
    const interval = setInterval(() => {
      setIsTransitioning(true);

      // Wait for fade out before changing banner
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % SPONSORS.length);
        setIsTransitioning(false);
      }, 300);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const currentSponsor = SPONSORS[currentIndex];

  return (
    <footer className="bg-white border-t fixed bottom-0 left-0 right-0 z-40">
      <div className="max-w-4xl mx-auto px-6 py-2">

        {/* Rotating Banner */}
        <div className="flex items-center justify-center">
          <a
            href={currentSponsor.link || '#'}
            target={currentSponsor.link ? '_blank' : '_self'}
            rel={currentSponsor.link ? 'noopener noreferrer' : undefined}
            onClick={() => trackFooterBannerClick(currentSponsor.alt, currentSponsor.link)}
            className={`transition-opacity duration-500 ${
              isTransitioning ? 'opacity-0' : 'opacity-100'
            }`}
          >
            <img
              src={currentSponsor.image}
              alt={currentSponsor.alt}
              className="max-w-full object-contain md:max-h-[80px] max-h-[50px]"
            />
          </a>
        </div>
      </div>
    </footer>
  );
}
